<template>
  <div>
    <parent></parent>
  </div>
</template>

<script>
import Parent from '../components/testComponents/Parent.vue'
export default {
  components:{
    Parent
  }
  
}
</script>

<style scoped>

</style>